import { render } from "./scrollOrderHistory.vue?vue&type=template&id=40da2003&scoped=true&ts=true"
import script from "./scrollOrderHistory.vue?vue&type=script&lang=ts"
export * from "./scrollOrderHistory.vue?vue&type=script&lang=ts"

import "./scrollOrderHistory.vue?vue&type=style&index=0&id=40da2003&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40da2003"]])

export default __exports__